import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { AppointmentStatus } from './appointment-status.interface';
import { AppointmentStatusService } from './appointment-status.service';

const service = new AppointmentStatusService();

export interface AppointmentStatusState {
   appointmentStatuses: Array<AppointmentStatus>;
}

const AppointmentStatusStore: Module<AppointmentStatusState, StoreState> = {
   namespaced: true,
   state: { appointmentStatuses: [] },
   getters: {},
   mutations: {
      SET_APPOINTMENT_STATUSES(state, appointmentStatuses: Array<AppointmentStatus>) {
         state.appointmentStatuses = appointmentStatuses;
      },
   },
   actions: {
      async getAppointmentStatuses(context, query?: LocationQuery) {
         const response = await service.getAppointmentStatuses(query);
         context.commit('SET_APPOINTMENT_STATUSES', response.data);
         return response.data;
      },
   },
};

export default AppointmentStatusStore;
